import React, { useState, useEffect } from 'react';
import { GithubPicker } from 'react-color';
import PropTypes from 'prop-types';
import { COLOR_PICKER } from '../../../shared/utils/constants';

const ColorPicked = (props) => {
  const { onHandleChange, colorSelected } = props;
  const [backgroundColor, setBackgroundColor] = useState();
  const [displayColorPicker, setDisplayColorPicker] = useState(false);

  const handleChange = (color) => {
    const { hex } = color;
    setBackgroundColor(hex);
    setDisplayColorPicker(!displayColorPicker);
  };

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker);
  };

  useEffect(() => {
    if (colorSelected === null) {
      setBackgroundColor(COLOR_PICKER);
    } else {
      setBackgroundColor(colorSelected);
    }
  }, []);

  useEffect(() => {
    onHandleChange(backgroundColor);
  }, [backgroundColor]);

  return (
    <div>
      <button
        type="button"
        style={{ background: backgroundColor }}
        className="color-picked"
        onClick={handleClick}
      />
      {displayColorPicker ? (
        <div className="color-picked-popover">
          <GithubPicker
            width="215px"
            onChange={(color) => {
              handleChange(color);
              onHandleChange(backgroundColor);
            }}
          />
        </div>
      ) : null}
    </div>
  );
};

ColorPicked.propTypes = {
  onHandleChange: PropTypes.func.isRequired,
  colorSelected: PropTypes.string,
};

ColorPicked.defaultProps = {
  colorSelected: null,
};

export default ColorPicked;
